import { CYLINDER } from '@/constants/object';
import * as THREE from 'three';
import { BaseObject, applyGeometryProperty, applyProperties } from './base';

export class Cylinder extends BaseObject {
  constructor() {
    super(
      new THREE.CylinderGeometry(
        CYLINDER.RADIUS_TOP,
        CYLINDER.RADIUS_BOTTOM,
        CYLINDER.HEIGHT,
        CYLINDER.RADIAL_SEGMENTS
      ),
      new THREE.MeshStandardMaterial({ color: CYLINDER.COLOR })
    );

    this.radiusTop = CYLINDER.RADIUS_TOP;
    this.radiusBottom = CYLINDER.RADIUS_BOTTOM;
    this.height = CYLINDER.HEIGHT;
    this.radialSegments = CYLINDER.RADIAL_SEGMENTS;

    this.getOutline();

    this.updateGeometry = () => {
      this.geometry.dispose();
      this.geometry = new THREE.CylinderGeometry(this.radiusTop, this.radiusBottom, this.height, this.radialSegments);
      this.getOutline();
    };

    this.applyProperties = (properties) => {
      applyProperties(this, properties, false);
      const needsUpdate =
        applyGeometryProperty(this, properties.radiusTop, 'radiusTop', CYLINDER.MIN_RADIUS) |
        applyGeometryProperty(this, properties.radiusBottom, 'radiusBottom', CYLINDER.MIN_RADIUS) |
        applyGeometryProperty(this, properties.height, 'height', CYLINDER.MIN_HEIGHT) |
        applyGeometryProperty(this, properties.radialSegments, 'radialSegments', CYLINDER.MIN_RADIAL_SEGMENTS);

      if (needsUpdate) this.updateGeometry();
    };
  }
}
